import React from "react";
import { Link } from "react-router";
import { Instagram } from "lucide-react";

function Footer() {
    const logo = (
        <img
            src={require('../../statics/img/VERDE-2.png')}
            alt="URB RACE"
            className="h-7 md:h-8 w-auto object-contain mr-2 transition-all"
        />
    );

    return (
        <footer className="app-footer flex flex-col sm:flex-row items-center justify-between px-4 sm:px-6 py-4 mt-auto bg-[#08090B] border-t border-[#181B21]">
            <div className="flex items-center gap-3">
                {logo}
                <span className="text-xs text-urb-text-muted">
                    © 2026 URB RACE · Todos os direitos reservados.
                </span>
            </div>

            <div className="flex items-center gap-4 mt-3 sm:mt-0 text-xs text-urb-text-muted">
                <Link to="/contato" className="hover:text-white transition-colors">
                    Suporte
                </Link>
                <Link to="/termos-servico" className="hover:text-white transition-colors">
                    Termos de Uso
                </Link>
                <Link to="/politica-privacidade" className="hover:text-white transition-colors">
                    Política de Privacidade
                </Link>
                <a
                    href="https://www.instagram.com/urb.race/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="hover:text-white transition-colors inline-flex items-center"
                >
                    <Instagram className="w-4 h-4" />
                </a>
            </div>
        </footer>
    );
}

export default Footer;